import lighten from '@utils/lighten';

function darken(color, percentage) {
  return lighten(color, percentage * -1);
}

export default darken;
